






import { Vue, Component, Watch } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  transitionName = 'fold-left'
  get isLogin() {
    return this.$store.getters.isLogin
  }

  @Watch('$route', { deep: true })
  onUrlChange(newval: any) {
    if (newval.meta.auth && !this.isLogin) {
      this.$router.replace({ path: '/' })
      this.$store.dispatch('login')
    }

    // const toDepth = newval && newval.path.split('/').length
    // const fromDepth = oldval && oldval.path.split('/').length

    // this.transitionName = ~~toDepth < ~~fromDepth ? 'fold-right' : 'fold-left'
  }

  async created() {
    await this.$store.dispatch('autoLogin')
    this.onUrlChange(this.$route)
  }
}
